import { Component, OnInit, ViewChild } from '@angular/core';
import { Listing } from 'src/app/shared/models/listing.model';
import { Languages, Service, ServiceStatus } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { ReportsService } from 'src/app/shared/services/reports.service';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/shared/services/app.config';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/front-user/shared/models/user.model';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { Country } from 'src/app/front-user/shared/models/country.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { Port } from 'src/app/front-user/shared/models/port.model';
//import { VesselType } from 'src/app/front-user/shared/models/vesselType.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { MyRequestsService } from 'src/app/shared/services/my-Requests.service';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';
import { ETenderAdminTypes } from 'src/app/shared/models/e-tender.model';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { Circular, Percentages } from 'src/app/shared/models/circular.model';
import { CircularService } from 'src/app/shared/services/circular.service';
import { CircularsVesselType } from 'src/app/front-user/shared/models/vessel-type.modal';

@Component({
  selector: 'app-circulars-reports',
  templateUrl: './circulars-reports.component.html',
  styleUrls: ['./circulars-reports.component.css']
})
export class CircularsReportsComponent implements OnInit {

  //#region Properties & Variables
  showAutoCompleteMinLengthMessage: Boolean;
  private collection: Listing;
  private itemsMenu: MenuItem[] = [];
  public sailDirections: SailDirection[] = [];
  lang: string;
  pageSize = 15;
  userName: string = "";
  requestNumber: string = "";
  isAdmin: Boolean;
  private isCircularsReportAdmin: boolean = false;
  creationDateFromFormatted: string = "";
  creationDateToFormatted: string = "";
  sailingDateFromFormatted: string = "";
  sailingDateToFormatted: string = "";
  decisionFeedbackDateFromFormatted: string = "";
  decisionFeedbackDateToFormatted: string = "";
  sortBy: string = "";
  sortDir: string = "";
  userId: string = "";
  userGroups: number[] = [];

  creationDateFrom: string = ""
  creationDateTo: string = ""
  statusId: string = ""
  rebateFileNumber: string = ""
  imo: string = ""
  sailingDateFrom: string = ""
  sailingDateTo: string = ""
  decisionFeedbackDateFrom: string = ""
  decisionFeedbackDateTo: string = ""
  fromPortId: string = ""
  toPortId: string = ""
  fromCountryId: string = ""
  toCountryId: string = ""
  fromRegionId: string = ""
  toRegionId: string = ""
  rebatePercentageValue: string = ""
  circularId: string = ""
  public circulars: Circular[] = [];
  // public selectedCircular: Circular;
  shipTypeId: string = ""
  shipName: string = ""
  isPassed: Boolean = null;
  isrefunded: Boolean = null;
  isClosed: Boolean = null;
  closureDateFrom: string = ""
  closureDateTo: string = ""
  directionId: string = "";
  exportngParametersUrl: string = "";

  ebookingReportLookups: EbookingReportLookups;
  public currentUser: User = new User();
  InvalidDateMessage: string;
  hideExportButton: Boolean
  isAutoCompleteLoading: Boolean
  agentsNamesList = [];
  agentNameNotFoundMessage: string;
  autoCompleteMinQueryLength: number = 3;
  AgentsNamesTextBoxPlaceHolder: string;
  showFromDateGreaterThanTodayDateMessage: Boolean
  showFromDateGreaterThanToDateMessage: Boolean
  showClosureFromDateGreaterThanClosureToDateMessage: Boolean
  showDecisionFeedbackDateFromGreaterThanTodayDateMessage: Boolean
  showDecisionFeedbackFromDateGreaterThanDecisionFeedbackDateToMessage: Boolean

  showClosedRequestsFiltersDiv: Boolean = false;
  public countries: GenericLookup[] = [];
  public ports: Port[] = [];
  public vesselTypes: GenericLookup[] = [];
  public vesselCircularsTypes: GenericLookup[] = [];
  public Percentages: Percentages[] = [];
  public uniquePercentages = [];
  public uniqueFromRegions = [];
  public uniqueToRegions = [];
  public lastPortsOrigin: Port[] = [];
  public firstPortsDestination: Port[] = [];
  public statusesList: [] = [];
  responseObj: ResponseObject;
  isErrorMessage: Boolean = false;

  @ViewChild('CircularsReport',{static: false}) gridView: GridViewComponent;
  HasMenu: boolean = true;
  IsHtml: boolean = true;
  //#endregion

  constructor(private etenderSrv: EtenderService, private route: Router, private myReportsService: ReportsService, private global: GlobalServices, private myRequestsService: MyRequestsService, private agentService: AgentService, private translate: TranslateService, private authenticationService: AuthenticationService, private router: Router, private localeService: BsLocaleService, private lookupService: LookupService, private circularService: CircularService, public datepipe: DatePipe) {
    this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
    this.currentUser = this.authenticationService.currentUserValue;
    this.etenderSrv.GetUserGroups(this.currentUser.Email).subscribe(
      data => {
        this.userGroups = data.Data;
        if (this.userGroups != null) {
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_MeasurementCommittee ||
            ug == ETenderAdminTypes.SCAServices_circulars_measurement_first ||
            ug == ETenderAdminTypes.SCAServices_circulars_measurement_second ||
            ug == ETenderAdminTypes.SCAServices_circulars_measurement_third ||
            ug == ETenderAdminTypes.SCAServices_circulars_Reports).length > 0) {
            this.isCircularsReportAdmin = true;
          }
        }

        if (!this.isCircularsReportAdmin)
          this.route.navigateByUrl('/workspace');
      },
      () => console.log('Something went wrong in GetUserGroups!!')
    );
  }


  myControl = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;


  async ngOnInit() {

    this.InvalidDateMessage = await this.translate.get('SHARED.InvalidDate').toPromise();
    this.AgentsNamesTextBoxPlaceHolder = await this.translate.get('SHARED.REPORTS.AGENT_NAME_MIN_CHARS').toPromise();

    this.currentUser = this.authenticationService.currentUserValue;
    //this.currentUser = this.global.user;
    enGbLocale.invalidDate = this.InvalidDateMessage;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
    if (this.currentUser.IsAdmin) {
      this.isAdmin = true;
    }
    else {
      this.router.navigate(['/workspace']);
    }
    this.loadCountries();
    this.loadCircularVesselTypes();
    this.loadSailDirections();
    this.loadLookups();
    this.loadCirculars();
    this.loadSearchCriteria();
    if (this.circularId !== "") {
      this.getPercentageAndRegionsByCircularId();
    }
    this.loadCircularsReport();
    this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
    this.agentNameNotFoundMessage = this.translate.instant('SHARED.NoItems');
  }

  // loadVesselTypes(): void {
  //   this.lookupService.getVesselTypes().subscribe(
  //     data => this.vesselTypes = data.Data as VesselType[],
  //     () => console.log("Something went wrong in getVesselTypes!!"),

  //   );
  // }
  loadCircularVesselTypes(): void {
    this.lookupService.getCircularsVesselTypes().subscribe(
      data => this.vesselTypes = data.Data as CircularsVesselType[],
      () => console.log("Something went wrong!!"),
      () => this.loadCircularVesselTypesCompleted()
    );
  }
  loadCircularVesselTypesCompleted(): void {
    var unique = [];
    var distinct = [];
    for (let i = 0; i < this.vesselTypes.length; i++) {
      if (!unique[this.vesselTypes[i].NameEN]) {
        distinct.push(this.vesselTypes[i]);
        unique[this.vesselTypes[i].NameEN] = 1;
      }
    }
    this.vesselCircularsTypes = distinct as CircularsVesselType[];
  }

  loadSailDirections(): void {
    this.lookupService.getSailDirections().subscribe(
      data => this.sailDirections = data.Data as SailDirection[],
      () => console.log("Something went wrong in getSailDirections!!"),
      () => console.log("Completed"),
    );
  }


  loadAgentsDisplayNames(keyWord: string) {
    this.isAutoCompleteLoading = true;
    this.agentService.GetAgentsInfoByDisplayName(keyWord).subscribe(s => {
      this.agentsNamesList = s.Data;
      this.isAutoCompleteLoading = false;
    });
  }

  get serviceSatatus() {
    return ServiceStatus;
  }

  getCircularsReportData() {

    this.removeAllValidationMessages()
    // if (this.isFromDateGreaterThanTodayDate()) {
    //   this.showFromDateGreaterThanTodayDateMessage = true;
    //   return;
    // }

    if (this.isCreationFromDateGreaterThanCreationToDate()) {
      this.showFromDateGreaterThanToDateMessage = true;
      return;
    }

    if (this.isClosureFromDateGreaterThanClosureToDate()) {
      this.showClosureFromDateGreaterThanClosureToDateMessage = true;

      return;
    }


    if (this.isDecisionFeedbackFromDateGreaterThanDecisionFeedbackToDate()) {
      this.showDecisionFeedbackFromDateGreaterThanDecisionFeedbackDateToMessage = true;
      return;
    }

    this.loadCircularsReport();
  }

  loadCircularsReport() {

    this.storeSearchCriteria();

    this.creationDateFrom = this.creationDateFrom == null ? "" : this.creationDateFrom;
    this.creationDateTo = this.creationDateTo == null ? "" : this.creationDateTo;
    if (this.creationDateFrom.toString() != this.InvalidDateMessage && this.creationDateTo.toString() != this.InvalidDateMessage) {
      this.global.isLoaderEnabled = true;
      this.creationDateFromFormatted = this.creationDateFrom == "" ? "" : this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
      this.creationDateToFormatted = this.creationDateTo == "" ? "" : this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');
      this.sailingDateFromFormatted = this.sailingDateFrom == "" ? "" : this.datepipe.transform(this.sailingDateFrom, 'MM/dd/yyyy');
      this.sailingDateToFormatted = this.sailingDateTo == "" ? "" : this.datepipe.transform(this.sailingDateTo, 'MM/dd/yyyy');
      this.decisionFeedbackDateFromFormatted = this.decisionFeedbackDateFrom == "" ? "" : this.datepipe.transform(this.decisionFeedbackDateFrom, 'MM/dd/yyyy');
      this.decisionFeedbackDateToFormatted = this.decisionFeedbackDateTo == "" ? "" : this.datepipe.transform(this.decisionFeedbackDateTo, 'MM/dd/yyyy');
      this.createExportingParametersUrl();
      this.myReportsService.getCircularsReport(0,
        this.pageSize,
        this.sortBy,
        this.sortDir,
        this.userId,
        encodeURIComponent(this.userName),
        this.requestNumber,
        this.creationDateFromFormatted,
        this.creationDateToFormatted,
        this.statusId,
        this.rebateFileNumber,
        this.imo,
        this.sailingDateFromFormatted,
        this.sailingDateToFormatted,
        this.fromCountryId,
        this.toCountryId,
        this.fromPortId,
        this.toPortId,
        this.fromRegionId,
        this.toRegionId,
        this.circularId,
        this.rebatePercentageValue,
        this.shipTypeId,
        encodeURIComponent(this.shipName),
        this.isPassed,
        this.isrefunded,
        this.isClosed,
        this.directionId,
        this.decisionFeedbackDateFromFormatted,
        this.decisionFeedbackDateToFormatted
      ).subscribe(
        s => {

          this.responseObj = s;
          if (!this.responseObj.Success) {
            this.isErrorMessage = true;
          }

          this.collection = s.Data;
          this.hideExportButton = s.Data.TotalNumber > 0 ? false : true;
        },
        () => console.log("Something went wrong in getCircularsReport!!"),
        () => this.loadCollectionCompleted());
    }
  }

  loadCollectionCompleted() {
    this.loadItemsMenu();
    var url = "Report/GetCircularsReport?pageIndex={PAGEINDEX}"
      + "&pageSize=" + this.pageSize
      + "&sortBy=" + this.sortBy
      + "&sortDir=" + this.sortDir
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + "&userId=" + this.userId
      + "&userName=" + encodeURIComponent(this.userName)
      + "&requestNumber=" + this.requestNumber
      + "&submissionDateFrom=" + this.creationDateFromFormatted
      + "&submissionDateTo=" + this.creationDateToFormatted
      + "&statusId=" + this.statusId
      + "&rebateFileNumber=" + this.rebateFileNumber
      + "&imo=" + this.imo
      + "&sailingDateFrom=" + this.sailingDateFromFormatted
      + "&sailingDateTo=" + this.sailingDateToFormatted
      + "&fromRegionId=" + this.fromRegionId
      + "&toRegionId=" + this.toRegionId
      + "&fromCountryId=" + this.fromCountryId
      + "&toCountryId=" + this.toCountryId
      + "&fromPortId=" + this.fromPortId
      + "&toPortId=" + this.toPortId
      + "&circularId=" + this.circularId
      + "&rebatePercentageValue=" + this.rebatePercentageValue
      + "&shipTypeId=" + this.shipTypeId
      + "&shipName=" + encodeURIComponent(this.shipName)
      + "&isPassed=" + this.isPassed
      + "&isrefunded=" + this.isrefunded
      + "&isClosed=" + this.isClosed
      + "&directionId=" + this.directionId
      + "&decisionFeedbackDateFrom=" + this.decisionFeedbackDateFromFormatted
      + "&decisionFeedbackDateTo=" + this.decisionFeedbackDateToFormatted;
    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      url, "SHARED.REPORTS.CIRCULARS_REPORT", this.itemsMenu, "", "", "");
    //Disable Loader
    this.global.isLoaderEnabled = false;
  }

  loadCirculars(): void {
    this.lookupService.getCirculars().subscribe(
      data => this.circulars = data.Data as Circular[],
      () => console.log("Something went wrong in getCirculars!!"),
    );
  }


  loadCountries(): void {
    this.lookupService.getCountries().subscribe(
      data => this.countries = data.Data as Country[],
      () => console.log("Something went wrong in getCountries!!"),
      () => this.loadCountriesCompleted()
    );
  }

  loadCountriesCompleted(): void {
    this.loadPorts();
  }
  loadPorts(): void {
    //this.lookupService.getPorts().subscribe((data: ResponseObject) => {
    //  this.ports = data.Data as Port[];
    //});
    this.lookupService.getPorts().subscribe(
      data => this.ports = data.Data as Port[],
      () => console.log("Something went wrong in getPorts!!"),
      () => this.loadPortsCompleted()
    );
  }

  loadPortsCompleted(): void {
    this.lastPortsOrigin = this.firstPortsDestination = this.ports.filter((item) => item.CountryId == this.countries[0].Id);

  }
  onLastCountrySelect(countryId: number): void {
    this.lastPortsOrigin = this.ports.filter((item) => item.CountryId == countryId);
  }
  onFirstCountrySelect(countryId: number): void {
    this.firstPortsDestination = this.ports.filter((item) => item.CountryId == countryId);
  }

  onCircularLookupSelect(): void {
    // this.SelectedCircular = this.circulars.find((obj) => {
    //   return obj.Id == CircularId;
    // });
    if (this.circularId == "") {
      this.rebatePercentageValue = "";
      this.toCountryId = "";
      this.fromCountryId = "";
      this.toPortId = "";
      this.fromPortId = "";
      this.toRegionId = "";
      this.fromRegionId = "";
    }
    this.getPercentageAndRegionsByCircularId();
  }
  getPercentageAndRegionsByCircularId() {
    this.Percentages = [];
    this.uniquePercentages = [];
    this.uniqueFromRegions = [];
    this.uniqueToRegions = [];
    this.circularService.getPercentagesByCircularId(this.circularId).subscribe(
      data => this.Percentages = data.Data as Percentages[],
      () => console.log("Something went wrong in getPercentagesByCircularId!!"),
      () => this.loadPercentageAndRegions()
    );
  }
  loadPercentageAndRegions() {
    for (var item, i = 0; item = this.Percentages[i++];) {
      var percentageId = item.Id;
      var percentageValue = item.PercentageValue;
      var fromRegionId = item.FromRegionId;
      var fromRegionName = item.CircularsRegions.NameEN;
      var toRegionId = item.ToRegionId;
      var toRegionName = item.CircularsRegions1.NameEN;
      if (this.uniquePercentages.find(p => p.PercentageValue == percentageValue) == undefined) {
        this.uniquePercentages.push({
          Id: percentageId,
          PercentageValue: percentageValue
        });
      }
      if (this.uniqueFromRegions.find(fr => fr.Id == fromRegionId) == undefined) {
        this.uniqueFromRegions.push({
          Id: fromRegionId,
          NameEN: fromRegionName
        });
      }
      if (this.uniqueToRegions.find(fr => fr.Id == toRegionId) == undefined) {
        this.uniqueToRegions.push({
          Id: toRegionId,
          NameEN: toRegionName
        });
      }
    }
  }

  resetFilters() {
    this.creationDateFrom = "";
    this.creationDateTo = "";
    this.creationDateFromFormatted = "";
    this.creationDateToFormatted = "";
    this.closureDateFrom = "";
    this.closureDateTo = "";
    this.creationDateToFormatted = "";

    this.decisionFeedbackDateFrom = "";
    this.decisionFeedbackDateFromFormatted = "";
    this.decisionFeedbackDateTo = "";
    this.decisionFeedbackDateToFormatted = "";

    this.statusId = "";
    this.userName = "";
    this.requestNumber = "";
    this.fromCountryId = "";
    this.toCountryId = "";
    this.fromPortId = "";
    this.toPortId = "";
    this.fromRegionId = "";
    this.toRegionId = "";
    this.rebateFileNumber = "";
    this.sailingDateFrom = "";
    this.sailingDateFromFormatted = "";
    this.sailingDateTo = "";
    this.sailingDateToFormatted = "";
    this.circularId = "";
    this.rebatePercentageValue = "";
    this.directionId = "";
    this.imo = "";
    this.shipName = "";
    this.shipTypeId = "";
    this.isrefunded = null;
    this.isPassed = null;
    this.isClosed = null;
    this.hideExportButton = false;
    this.showFromDateGreaterThanTodayDateMessage = false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.showClosureFromDateGreaterThanClosureToDateMessage = false;
    this.showDecisionFeedbackDateFromGreaterThanTodayDateMessage = false;
    this.showDecisionFeedbackFromDateGreaterThanDecisionFeedbackDateToMessage = false;
    this.showClosedRequestsFiltersDiv = false;
    this.loadCircularsReport();
  }

  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].TitleAr = "التفاصيل";
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = "Request History";
    this.itemsMenu[1].TitleAr = "تاريخ الطلب";
    if (this.currentUser.IsAdmin) {
      this.itemsMenu[2] = new MenuItem();
      this.itemsMenu[2].Title = "Workflow Status";
      this.itemsMenu[2].TitleAr = "حالة مسار العمل";
      this.itemsMenu[3] = new MenuItem();
      this.itemsMenu[3].Title = "Confirm Ship Passing";
      this.itemsMenu[3].TitleAr = "تأكيد عبور السفينة";
      this.itemsMenu[4] = new MenuItem();
      this.itemsMenu[4].Title = "Refund/Close";
      this.itemsMenu[4].TitleAr = "تسوية/اغلاق";
    }
  }

  loadLookups() {
    this.myReportsService.getEbookingReportLookups().subscribe(
      data => this.ebookingReportLookups = data.Data,
      () => console.log("Something went wrong in getEbookingReportLookups!!"),
      () => console.log("Completed"));



    this.myRequestsService.getMyRequestsStatusesLookups(Service.circulars).subscribe(
      response => this.statusesList = response.Data.Statuses,
      () => console.log("Something went wrong in getMyRequestsStatusesLookups!!"),
      () => console.log("Completed"),

    );

  }
  async MeasurementExport() {
    let response = await this.translate.get('SHARED.REPORTS.CIRCULARS_MEASUREMENT_OBJECT').toPromise();
    let circularsObjectAsString = JSON.stringify(response)
    let ExportExcellUrl = AppConfig.settings.apiServer.apiUrlAdmin +
      "Report/ExportCircularsMeasurementReportExcel?circularsObjectAsString=" + circularsObjectAsString + this.exportngParametersUrl;
    window.open(ExportExcellUrl, '_self');
  }

  async EconomicExport() {
    let response = await this.translate.get('SHARED.REPORTS.CIRCULARS_ECONOMIC_OBJECT').toPromise();
    console.log(response);
    let circularsObjectAsString = JSON.stringify(response)
    let ExportExcellUrl = AppConfig.settings.apiServer.apiUrlAdmin +
      "Report/ExportCircularsEconomicReportExcel?circularsObjectAsString=" + circularsObjectAsString + this.exportngParametersUrl;
    window.open(ExportExcellUrl, '_self');
  }

  createExportingParametersUrl() {
    this.exportngParametersUrl = "&sortBy=" + this.sortBy
      + "&sortDir=" + this.sortDir
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + "&userId=" + this.userId
      + "&userName=" + encodeURIComponent(this.userName)
      + "&requestNumber=" + this.requestNumber
      + "&submissionDateFrom=" + this.creationDateFromFormatted
      + "&submissionDateTo=" + this.creationDateToFormatted
      + "&statusId=" + this.statusId
      + "&rebateFileNumber=" + this.rebateFileNumber
      + "&imo=" + this.imo
      + "&sailingDateFrom=" + this.sailingDateFromFormatted
      + "&sailingDateTo=" + this.sailingDateToFormatted
      + "&fromCountryId=" + this.fromCountryId
      + "&toCountryId=" + this.toCountryId
      + "&fromPortId=" + this.fromPortId
      + "&toPortId=" + this.toPortId
      + "&fromRegionId=" + this.fromRegionId
      + "&toRegionId=" + this.toRegionId
      + "&circularId=" + this.circularId
      + "&rebatePercentageValue=" + this.rebatePercentageValue
      + "&shipTypeId=" + this.shipTypeId
      + "&shipName=" + encodeURIComponent(this.shipName)
      + "&isPassed=" + this.isPassed
      + "&isrefunded=" + this.isrefunded
      + "&isClosed=" + this.isClosed
      + "&directionId=" + this.directionId
      + "&decisionFeedbackDateFrom=" + this.decisionFeedbackDateFromFormatted
      + "&decisionFeedbackDateTo=" + this.decisionFeedbackDateToFormatted;

  }
  keyword = 'DisplayName';
  selectAgentNameEvent(item) {
    this.userName = item.DisplayName;
  }


  onAgentsNamesSearchChange(val: string) {
    this.loadAgentsDisplayNames(val);
  }

  onFocused(e) {
  }


  storeSearchCriteria() {
    this.global.circularsReportSearchCriteria = [];
    this.global.circularsReportSearchCriteria.push({
      creationDateFrom: this.creationDateFrom,
      creationDateTo: this.creationDateTo,
      requestNumber: this.requestNumber,
      statusId: this.statusId,
      userName: this.userName,
      rebateFileNumber: this.rebateFileNumber,
      imo: this.imo,
      sailingDateFrom: this.sailingDateFrom,
      sailingDateTo: this.sailingDateTo,
      circularId: this.circularId,
      rebatePercentageValue: this.rebatePercentageValue,
      shipTypeId: this.shipTypeId,
      shipName: this.shipName,
      fromCountryId: this.fromCountryId,
      fromPortId: this.fromPortId,
      toCountryId: this.toCountryId,
      toPortId: this.toPortId,
      fromRegionId: this.fromRegionId,
      toRegionId: this.toRegionId,
      isrefunded: this.isrefunded,
      isPassed: this.isPassed,
      isClosed: this.isClosed,
      directionId: this.directionId,
      decisionFeedbackDateFrom: this.decisionFeedbackDateFrom,
      decisionFeedbackDateTo: this.decisionFeedbackDateTo
    });




  }

  loadSearchCriteria() {
    if (this.global.circularsReportSearchCriteria.length > 0) {

      this.creationDateFrom = this.global.circularsReportSearchCriteria[0].creationDateFrom;
      this.creationDateTo = this.global.circularsReportSearchCriteria[0].creationDateTo;
      this.requestNumber = this.global.circularsReportSearchCriteria[0].requestNumber;
      this.statusId = this.global.circularsReportSearchCriteria[0].statusId;
      this.userName = this.global.circularsReportSearchCriteria[0].userName;
      this.rebateFileNumber = this.global.circularsReportSearchCriteria[0].rebateFileNumber;
      this.imo = this.global.circularsReportSearchCriteria[0].imo;
      this.sailingDateFrom = this.global.circularsReportSearchCriteria[0].sailingDateFrom;
      this.sailingDateTo = this.global.circularsReportSearchCriteria[0].sailingDateTo;
      this.circularId = this.global.circularsReportSearchCriteria[0].circularId;
      this.rebatePercentageValue = this.global.circularsReportSearchCriteria[0].rebatePercentageValue;
      this.shipTypeId = this.global.circularsReportSearchCriteria[0].shipTypeId;
      this.shipName = this.global.circularsReportSearchCriteria[0].shipName;
      this.fromCountryId = this.global.circularsReportSearchCriteria[0].fromCountryId;
      this.fromPortId = this.global.circularsReportSearchCriteria[0].fromPortId;
      this.toCountryId = this.global.circularsReportSearchCriteria[0].toCountryId;
      this.toPortId = this.global.circularsReportSearchCriteria[0].toPortId;
      this.fromRegionId = this.global.circularsReportSearchCriteria[0].fromRegionId;
      this.toRegionId = this.global.circularsReportSearchCriteria[0].toRegionId;
      this.isrefunded = this.global.circularsReportSearchCriteria[0].isrefunded;
      this.isPassed = this.global.circularsReportSearchCriteria[0].isPassed;
      this.isClosed = this.global.circularsReportSearchCriteria[0].isClosed;
      this.directionId = this.global.circularsReportSearchCriteria[0].directionId;
      this.decisionFeedbackDateFrom = this.global.circularsReportSearchCriteria[0].decisionFeedbackDateFrom;
      this.decisionFeedbackDateTo = this.global.circularsReportSearchCriteria[0].decisionFeedbackDateTo;
      this.global.circularsReportSearchCriteria = [];

    }
  }

  isCreationFromDateGreaterThanCreationToDate(): Boolean {
    var isFromDateGreaterThanToDate = false;
    if (this.creationDateTo) {
      isFromDateGreaterThanToDate = this.creationDateFrom > this.creationDateTo;
    }
    return isFromDateGreaterThanToDate;
  }

  isClosureFromDateGreaterThanClosureToDate(): Boolean {
    this.closureDateFrom

    var isClosureFromDateGreaterThanClosureToDate = false;
    if (this.closureDateTo) {
      isClosureFromDateGreaterThanClosureToDate = this.closureDateFrom > this.closureDateTo;
    }
    return isClosureFromDateGreaterThanClosureToDate;
  }




  isDecisionFeedbackFromDateGreaterThanDecisionFeedbackToDate(): Boolean {

    var isDecisionFeedbackFromDateGreaterThanDecisionFeedbackToDate = false;
    if (this.decisionFeedbackDateTo) {
      isDecisionFeedbackFromDateGreaterThanDecisionFeedbackToDate = this.decisionFeedbackDateFrom > this.decisionFeedbackDateTo;
    }
    return isDecisionFeedbackFromDateGreaterThanDecisionFeedbackToDate;
  }

  isFromDateGreaterThanTodayDate(): Boolean {

    var isFromDateGreaterThanTodayDate = false;
    var today = new Date();
    var todayDate = this.datepipe.transform(today, 'MM/dd/yyyy');
    var selectedCreationDateFrom = this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
    isFromDateGreaterThanTodayDate = selectedCreationDateFrom > todayDate;
    return isFromDateGreaterThanTodayDate;
  }
  removeAllValidationMessages() {
    this.showFromDateGreaterThanTodayDateMessage = false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.showClosureFromDateGreaterThanClosureToDateMessage = false;
    this.showDecisionFeedbackDateFromGreaterThanTodayDateMessage = false;
    this.showClosureFromDateGreaterThanClosureToDateMessage = false;
    this.showDecisionFeedbackFromDateGreaterThanDecisionFeedbackDateToMessage = false;
  }

  numericOnly(event: any): boolean {
    let pattern = /^\d+$/;
    let entredValue;
    let result;
    let clipboard = (event.originalEvent || event).clipboardData;
    if (clipboard === undefined || clipboard === null) {
      entredValue = event.key;
    }
    else {

      entredValue = clipboard.getData('text');
    }
    result = pattern.test(entredValue);
    return result;
  }
  confirmShipPassing(rebateRequestId){
    this.route.navigate(['CircularRequest/ConfirmShipPassing'], { state: { data: { requestId: rebateRequestId } } });
  }
  closeRefund(rebateRequestId){
    this.route.navigate(['CircularRequest/RefundClose'], { state: { data: { requestId: rebateRequestId } } });
  }
}

export class MenuItem {
  Title: string;
  TitleAr: string;
};

export class EbookingReportLookups {
  public Services = [];
  public Statuses = [];
};


